import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ImageOverlay, Polyline } from '@tcc/treadstone';
import { getActiveSubLayer } from '../../../selectors/layerSelectors';

function OtherImageryMap({ bounds, field, image }) {
  if (!bounds.length || !image) {
    return null;
  }

  return (
    <div data-test-id="dmb-other-imagery-map">
      <ImageOverlay bounds={bounds} url={image} />
      <Polyline color="white" positions={field.boundary.coordinates} />
    </div>
  );
}

OtherImageryMap.propTypes = {
  bounds: PropTypes.array.isRequired,
  field: PropTypes.object.isRequired,
  image: PropTypes.string.isRequired,
};

function mapStateToProps(state, props) {
  const subLayer = getActiveSubLayer(state, props);

  return {
    bounds: subLayer
      ? [subLayer.northeastPoint, subLayer.southwestPoint]
      : [],
    image: subLayer?.imageUri ?? '',
    field: state.field,
  };
}

export default connect(mapStateToProps)(OtherImageryMap);
